import React from "react";
import { CheckCircle, Clock, XCircle, HelpCircle } from "lucide-react";

const statusMap = {
  resolved: {
    color: "bg-green-100 text-green-700",
    icon: <CheckCircle className="w-4 h-4 mr-1" />,
    label: "Resolved",
  },
  pending: {
    color: "bg-yellow-100 text-yellow-700",
    icon: <Clock className="w-4 h-4 mr-1" />,
    label: "Pending",
  },
  dismissed: {
    color: "bg-red-100 text-red-700",
    icon: <XCircle className="w-4 h-4 mr-1" />,
    label: "Dismissed",
  },
  default: {
    color: "bg-gray-100 text-gray-500",
    icon: <HelpCircle className="w-4 h-4 mr-1" />,
    label: "Unknown",
  },
};

const StatusBadge = ({ status, children }) => {
  const s = statusMap[status?.toLowerCase()] || statusMap.default;
  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap ${s.color}`}
      title={s.label}
    >
      {s.icon}
      {children || s.label}
    </span>
  );
};

export default StatusBadge; 